const GRADIENT_ID = "mail-header-grad";

/** Icône mail inline — PWA standalone sans dépendance à /suite/mcv-shared/. */
export function MailHeaderBrandIcon() {
  const stroke = `url(#${GRADIENT_ID})`;

  return (
    <svg className="mcv-app-header__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id={GRADIENT_ID} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="var(--mail-accent-gradient-from, #ce9bdd)" />
          <stop offset="100%" stopColor="var(--mail-accent-gradient-to, #71baff)" />
        </linearGradient>
      </defs>
      <rect width="20" height="16" x="2" y="4" rx="2" stroke={stroke} strokeWidth="1.5" />
      <path
        d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
